<div class="nova-font-style padding-15">
    <!-- SUMMARY -->
    <div class="row colstyle" *ngIf="(summaryData?.wizardData | json) != '{}'">
        <div class="col s12 m4 l4 xl4 center-align">
            <div class="bold headingtext">SSN</div>
            <div class="bold headingdata">{{summaryData?.wizardData?.empSSN}}</div>
        </div>
        <div class="col s12 m4 l4 xl4 center-align">
            <div class="bold headingtext">Last Name</div>
            <div class="bold headingdata">{{summaryData?.wizardData?.personDetails?.lastName}}</div>
        </div>
        <div class="col s12 m4 l4 xl4 center-align">
            <div class="bold headingtext">Date of Birth</div>
            <div class="bold headingdata">{{summaryData?.wizardData?.personDetails?.dateOfBirth | date: 'MM/dd/yyyy'}}
            </div>
        </div>
    </div>
    <h2 class="top-padding-15">Contact Information</h2>
    <div class="top-margin-15">
        <div class="left-padding-0">
            <form [formGroup]="contactInfoForm">
                <div class="row">
                    <div class="col s12 m12 l12 xl12 top-margin-15 left-padding-0">
                        <div class="form-group">
                            <div class="col s12 m6 l6 xl4 margin-5">
                                <label for="proofOfBirth" class="control-label bold right-margin-10">Proof of Birth<span
                                        class="k-required">*</span>:</label>
                                <kendo-dropdownlist [defaultItem]="defaultProofofBirth" id="proofOfBirth"
                                    [data]="config.ProofofBirthOptions" class="width-100p input-auto-width"
                                    [textField]="'name'" [valueField]="'id'" formControlName="proofOfBirthType"
                                    [valuePrimitive]="true" (selectionChange)="selectionChange($event)">
                                </kendo-dropdownlist>
                            </div>
                            <div class="col s12 m5 l5 xl4 margin-5" *ngIf="isIdentifireVisible">
                                <label for="customerIdentifierNo" class="control-label bold right-margin-10">Customer
                                    identifier<span class="k-required">*</span>:</label>
                                <kendo-maskedtextbox id="customerIdentifierNo" class="auto-width"
                                    [mask]="identifierMask" [rules]="rules" [value]="value"
                                    formControlName="customerIdentifierNo">
                                </kendo-maskedtextbox>
                            </div>
                        </div>
                    </div>
                    <div class="col s12 m12 l12 xl12 top-margin-15 left-padding-0">
                        <div class="form-group">
                            <div class="col s12 m8 l4 xl4 margin-5">
                                <label for="addressLine1" class="control-label bold">Address1<span
                                        class="k-required">*</span>:</label>
                                <input type="text" class="k-textbox left-margin-5" maxlength="35" id="addressLine1"
                                    formControlName="addressLine1" />
                                <div class="top-margin-1">
                                    <span class="custom-tooltip-validation"
                                        *ngIf="contactInfoForm.controls.addressLine1.touched && contactInfoForm.controls.addressLine1.errors">
                                        Address1 is required
                                    </span>
                                </div>
                            </div>
                            <div class="col s12 m8 l3 xl3 margin-5">
                                <label for="addressLine1" class="control-label bold">Address2:</label>
                                <input type="text" class="k-textbox left-margin-5" maxlength="35" id="addressLine2"
                                    formControlName="addressLine2" />
                            </div>
                            <div class="col s12 m8 l3 xl3 margin-5">
                                <label for="city" class="control-label bold" id="city-name">City<span
                                        class="k-required">*</span>:</label>
                                <input type="text" id="city" maxlength="33" class="k-textbox left-margin-5"
                                    formControlName="city" />
                                <div class="top-margin-1">
                                    <span class="custom-tooltip-validation"
                                        *ngIf="contactInfoForm.controls.city.touched && contactInfoForm.controls.city.errors">
                                        City is required
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col s12 m12 l12 xl12 top-margin-5 left-padding-0">
                        <div class="form-group">
                            <div class="col s12 m8 l3 xl3 margin-5 right-padding-0">
                                <label for="state" id="state-label"
                                    class="control-label bold right-margin-28">State<span
                                        class="k-required">*</span>:</label>
                                <kendo-dropdownlist [defaultItem]="defaultState" id="state" class="left-margin-5"
                                    [data]="states" [textField]="'name'" [valueField]="'abbreviation'"
                                    formControlName="state" [valuePrimitive]="true">
                                </kendo-dropdownlist>
                                <div class="top-margin-1">
                                    <span class="custom-tooltip-validation"
                                        *ngIf="contactInfoForm.controls.state.touched && contactInfoForm.controls.state.errors">
                                        State is required
                                    </span>
                                </div>
                            </div>
                            <div class="col s12 m8 l2 xl2 margin-5 padding-0 custom-padding">
                                <label for="zip" class="control-label bold" id="zip-label">Zip<span
                                        class="k-required">*</span>:</label>
                                <kendo-maskedtextbox id="zip" [mask]="zipMask" class="left-margin-5"
                                    formControlName="zip">
                                </kendo-maskedtextbox>
                                <div class="top-margin-1">
                                    <span class="custom-tooltip-validation left-margin-40 custom-left-margin-80"
                                        *ngIf="contactInfoForm.controls.zip.touched && contactInfoForm.controls.zip.errors">
                                        Zip is required
                                    </span>
                                </div>
                            </div>
                            <div class="col s12 m8 l2 xl2 margin-5 padding-0 custom-padding">
                                <label for="zip4" class="control-label bold" id="zip4-label">Zip+4:</label>
                                <kendo-maskedtextbox id="zip4" [mask]="zip4Mask" class="left-margin-5"
                                    formControlName="zip4">
                                </kendo-maskedtextbox>
                            </div>
                            <div class="col s12 m8 l3 xl3 margin-5 padding-0 custom-padding">
                                <label for="phoneNo" class="control-label bold right-margin-10">Phone No<span
                                        class="k-required">*</span>:</label>
                                <kendo-maskedtextbox id="phoneNo" class="auto-width" [mask]="phoneMask"
                                    [value]="phoneValue" formControlName="phoneNo">
                                </kendo-maskedtextbox>
                                <div class="top-margin-1">
                                    <span class="custom-tooltip-validation"
                                        *ngIf="contactInfoForm.controls.phoneNo.touched && contactInfoForm.controls.phoneNo.errors">
                                        Phone no. is required
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col s12 m12 l12 xl12 top-margin-5 left-padding-0">
                        <div class="form-group">
                            <div class="col s12 m12 l6 xl5 margin-5">
                                <label for="workEmail" class="control-label bold" id="work-email">Work Email<span
                                        class="k-required">*</span>:</label>
                                <input type="text" class="k-textbox left-margin-5" maxlength="200" id="workEmail"
                                    formControlName="workEmail" placeholder="e.g. myname@example.net" />
                                <div class="top-margin-1">
                                    <div
                                        *ngIf="contactInfoForm.controls.workEmail.errors && (contactInfoForm.controls.workEmail.touched || contactInfoForm.controls.workEmail.dirty)">
                                        <span class="custom-tooltip-validation left-margin-100 custom-left-margin-120"
                                            *ngIf="contactInfoForm.controls.workEmail.errors.required">Work
                                            email is required</span>
                                        <span class="custom-tooltip-validation left-margin-100 custom-left-margin-120"
                                            *ngIf="contactInfoForm.controls.workEmail.errors.email">Enter valid
                                            email address</span>
                                        <span class="custom-tooltip-validation left-margin-100 custom-left-margin-120"
                                            *ngIf="contactInfoForm.controls.workEmail.errors.maxlength">Email must
                                            be at most 200 characters long</span>
                                    </div>
                                </div>
                            </div>
                            <div class="col s12 m12 l5 xl5 margin-5 right-padding-0">
                                <label for="personalEmail" class="control-label bold">Personal Email:</label>
                                <input type="text" class="k-textbox left-margin-5" maxlength="200" id="personalEmail"
                                    formControlName="personalEmail" placeholder="e.g. myname@example.net" />
                                <div class="top-margin-1">
                                    <div
                                        *ngIf="contactInfoForm.controls.personalEmail.errors && (contactInfoForm.controls.personalEmail.touched || contactInfoForm.controls.personalEmail.dirty)">
                                        <span class="custom-tooltip-validation left-margin-120"
                                            *ngIf="contactInfoForm.controls.personalEmail.errors.email">Enter valid
                                            email address</span>
                                        <span class="custom-tooltip-validation left-margin-120"
                                            *ngIf="contactInfoForm.controls.personalEmail.errors.maxlength">Email must
                                            be at most 200 characters long</span>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
            <div class="row">
                <div class="col s12 m12 l6 xl6 left-padding-0">
                    <div class="padding-75">
                        <label class="control-label bold">Upload Proof of Birth Document:</label>
                        <kendo-upload #upload id="contact-upload" [multiple]="false" [autoUpload]="false"
                            [restrictions]="fileRestrictions" (select)="onSelectEvent($event)"
                            (remove)="onRemoveEvent($event)">
                            <kendo-upload-messages [select]="'Select a file...'">
                            </kendo-upload-messages>
                        </kendo-upload>
                    </div>
                </div>
                <div class="col s12 m12 l5 xl5 left-padding-0"
                    *ngIf="summaryData?.wizardData?.contactDetails?.uploadedFileName">
                    <div class="padding-75 grid-display">
                        <label class="control-label bold">Previously Uploaded File:</label>
                        <span class="top-margin-10"
                            (click)="downloadUploadedFile(summaryData); summaryData.docClicked=!summaryData.docClicked">
                            <a class="clone-link"
                                *ngIf="!summaryData.docClicked">{{summaryData?.wizardData?.contactDetails?.uploadedFileName}}</a>
                            <span *ngIf="summaryData.docClicked" class="k-icon k-i-loading inner"></span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="stroke-separator"></div>
    <div class="row top-margin-15">
        <div class="col s12 m12 l6 xl6">
            <button type="button" (click)="goToPreviousPage(1)" class="btn btn-fullwidth background-red">
                <span class="k-icon k-i-arrow-chevron-left"></span> Previous
            </button>
        </div>
        <div class="col s12 m12 l6 xl6 align-right">
            <button kendoButton type="submit" (click)="submitContactData(0)" id="save-btn"
                class="btn btn-fullwidth background-red" [disabled]="submitBtnDisable() || displayload">
                <span *ngIf="!displayload">Submit</span>
                <span *ngIf="displayload" class="k-icon k-i-loading inner"></span>
            </button>
        </div>
    </div>
</div>